import { Action, createReducer, on } from '@ngrx/store';
import { PatientsActions } from '../../patients/state/patients.actions';
import { AppointmentSettingsActions } from './appointment-settings.actions';

export const STORE_FEATURE_KEY_APPOINTMENT_SETTINGS = 'appointmentSettings';

export interface AppointmentSettingsState {
    displayBirthday: boolean;
    displayTwoway: boolean;
    displayIncorrectDestinator: boolean;
    showProviders: boolean;
    loading: boolean;
}

export const initializeAppointmentSettingsState: AppointmentSettingsState = {
    displayBirthday: false,
    displayTwoway: false,
    displayIncorrectDestinator: false,
    showProviders: false,
    loading: false
};

const reducer = createReducer(
    initializeAppointmentSettingsState,
    on(AppointmentSettingsActions.getAppointmentSettingsSuccess, PatientsActions.getPatientSettingsSuccess,
        (state, { displayTwoway, displayBirthday, displayIncorrectDestinator, showProviders }) =>
        ({ ...state,
           displayBirthday,
           displayTwoway,
           displayIncorrectDestinator,
           showProviders
        })),
    on(AppointmentSettingsActions.saveAppointmentSettings, (state, payload) =>
        ({ ...state,
           loading: true
        })),
    on(AppointmentSettingsActions.saveAppointmentSettingsSuccess,
        (state, { displayTwoway, displayBirthday, displayIncorrectDestinator, showProviders }) =>
        ({ ...state,
           loading: false,
           displayBirthday,
           displayTwoway,
           displayIncorrectDestinator,
           showProviders
        }))
);

export function AppointmentSettingsReducers(state: AppointmentSettingsState | undefined, action: Action): AppointmentSettingsState {
    return reducer(state, action);
}
